module.exports = __webpack_public_path__ + "img/education.37e33b8a.webp";